import React from "react";
import { Fade } from "react-reveal";
import ListTile from "../../common/ListTile";
import {
  MyReviewBox,
  Title,
  SubTitle,
  SentenceContainer,
} from "./review_element";

const MyReviewItem = ({ index, heading, subheading, icon }) => {
  var split = heading.split(" ");
  var first = split[0];
  var second = split[1];
  var text = first.substring(0, 1) + second.substring(0, 1);

  return (
    <MyReviewBox>
      <Fade bottom duration={index * 500}>
        <ListTile
          leading={<SentenceContainer>{text}</SentenceContainer>}
          title={<Title>{heading}</Title>}
          subtitle={<SubTitle>{subheading}</SubTitle>}
        ></ListTile>
      </Fade>
    </MyReviewBox>
  );
};

export default MyReviewItem;
